import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data =[
    {
        "creditedDate": "2021-07-28T06:02:30.0000000Z",
        "share": 0.00010412392678618456,
        "mojo": 182216871,
        "block": 634272,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T05:44:35.0000000Z",
        "share": 0.00011068649782250044,
        "mojo": 193701371,
        "block": 634230,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T05:39:09.0000000Z",
        "share": 0.00012332160138019694,
        "mojo": 215812802,
        "block": 634194,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T05:36:16.0000000Z",
        "share": 0.00012322478638334729,
        "mojo": 215643376,
        "block": 634173,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T05:33:21.0000000Z",
        "share": 0.00012980908642668036,
        "mojo": 227165901,
        "block": 634154,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T05:03:55.0000000Z",
        "share": 0.00014297307263598112,
        "mojo": 250202877,
        "block": 634051,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T05:01:00.0000000Z",
        "share": 0.00014297307263598112,
        "mojo": 250202877,
        "block": 634053,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T04:55:33.0000000Z",
        "share": 0.00014297307263598112,
        "mojo": 250202877,
        "block": 634055,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T04:35:07.0000000Z",
        "share": 0.00014317242809731612,
        "mojo": 250551749,
        "block": 634010,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T04:20:43.0000000Z",
        "share": 0.0001369887227348252,
        "mojo": 239730264,
        "block": 633950,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T04:17:49.0000000Z",
        "share": 0.00013705713282373064,
        "mojo": 239849982,
        "block": 633942,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T04:14:54.0000000Z",
        "share": 0.00015030840100637062,
        "mojo": 263039701,
        "block": 633931,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T03:59:30.0000000Z",
        "share": 0.00016374012013242877,
        "mojo": 286545210,
        "block": 633867,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T03:51:33.0000000Z",
        "share": 0.0001638569949176846,
        "mojo": 286749741,
        "block": 633833,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T03:48:39.0000000Z",
        "share": 0.00016396907564390656,
        "mojo": 286945882,
        "block": 633827,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T03:45:42.0000000Z",
        "share": 0.00015719186037728794,
        "mojo": 275085755,
        "block": 633848,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T03:40:17.0000000Z",
        "share": 0.00017108661652654264,
        "mojo": 299401578,
        "block": 633799,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T03:34:53.0000000Z",
        "share": 0.00016457975991741706,
        "mojo": 288014579,
        "block": 633784,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T03:31:58.0000000Z",
        "share": 0.00016462232293568122,
        "mojo": 288089065,
        "block": 633779,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T03:29:01.0000000Z",
        "share": 0.00015820607915364852,
        "mojo": 276860638,
        "block": 633759,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T03:23:33.0000000Z",
        "share": 0.00015813964857501616,
        "mojo": 276744385,
        "block": 633765,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T02:58:33.0000000Z",
        "share": 0.00015842624816300613,
        "mojo": 277245934,
        "block": 633692,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T02:53:09.0000000Z",
        "share": 0.0001582890654062545,
        "mojo": 277005864,
        "block": 633675,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T02:36:13.0000000Z",
        "share": 0.00019180477303724138,
        "mojo": 335658352,
        "block": 633597,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T02:33:17.0000000Z",
        "share": 0.00018522256796153175,
        "mojo": 324139493,
        "block": 633607,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T02:25:23.0000000Z",
        "share": 0.00018524464511191562,
        "mojo": 324178128,
        "block": 633567,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T02:19:58.0000000Z",
        "share": 0.00018524464511191562,
        "mojo": 324178128,
        "block": 633566,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T02:17:03.0000000Z",
        "share": 0.00018524464511191562,
        "mojo": 324178128,
        "block": 633565,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T02:02:03.0000000Z",
        "share": 0.00015204956090624525,
        "mojo": 266086731,
        "block": 633506,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T01:46:40.0000000Z",
        "share": 0.0001584179329100054,
        "mojo": 277231382,
        "block": 633445,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T01:43:46.0000000Z",
        "share": 0.00015827081476602883,
        "mojo": 276973925,
        "block": 633434,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T01:06:16.0000000Z",
        "share": 0.0001577534383729514,
        "mojo": 276068517,
        "block": 633319,
        "isWinner": true
    },
    {
        "creditedDate": "2021-07-28T00:53:18.0000000Z",
        "share": 0.0001445074916645981,
        "mojo": 252888110,
        "block": 633275,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T00:47:53.0000000Z",
        "share": 0.00015727210685117672,
        "mojo": 275226186,
        "block": 633257,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T00:34:57.0000000Z",
        "share": 0.000137589680309004,
        "mojo": 240781940,
        "block": 633236,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T00:24:29.0000000Z",
        "share": 0.00013752309083463524,
        "mojo": 240665408,
        "block": 633203,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T00:16:32.0000000Z",
        "share": 0.00015033185282111006,
        "mojo": 263080742,
        "block": 633160,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T00:08:34.0000000Z",
        "share": 0.0001503944955192776,
        "mojo": 263190367,
        "block": 633149,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T00:03:11.0000000Z",
        "share": 0.00013070412843746586,
        "mojo": 228732224,
        "block": 633107,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-28T00:00:17.0000000Z",
        "share": 0.00013070412843746586,
        "mojo": 228732224,
        "block": 633110,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T23:57:21.0000000Z",
        "share": 0.00013711977696867982,
        "mojo": 239959609,
        "block": 633092,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T23:39:24.0000000Z",
        "share": 0.0001698923733922406,
        "mojo": 297311653,
        "block": 633041,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T23:31:29.0000000Z",
        "share": 0.00017627665789565685,
        "mojo": 308484151,
        "block": 633024,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T23:28:35.0000000Z",
        "share": 0.00017633708065430538,
        "mojo": 308589891,
        "block": 632999,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T23:06:04.0000000Z",
        "share": 0.0001704101037545934,
        "mojo": 298217681,
        "block": 632903,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T22:58:10.0000000Z",
        "share": 0.00017723396853112425,
        "mojo": 310159444,
        "block": 632871,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T22:55:14.0000000Z",
        "share": 0.0001704829320356889,
        "mojo": 298345131,
        "block": 632890,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T22:47:20.0000000Z",
        "share": 0.00018387954703349648,
        "mojo": 321789207,
        "block": 632852,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T22:42:34.0000000Z",
        "share": 0.0001839673123149266,
        "mojo": 321942796,
        "block": 632846,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T22:39:41.0000000Z",
        "share": 0.00017742438928225262,
        "mojo": 310492681,
        "block": 632826,
        "isWinner": false
    },
    {
        "creditedDate": "2021-07-27T22:36:47.0000000Z",
        "share": 0.00019044272000927004,
        "mojo": 333274760,
        "block": 632817,
        "isWinner": false
    }
]
/* eslint-disable global-require */
mock.onGet('/farmsRounds/data').reply(() => [200, data])